// @flow
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getDataChart } from '../../actions/earnings'
import { ChartCard } from '../../styles/mixins'
import { xAxisLabel } from './style'
import { Chart, Axis, Tooltip, Geom, Legend, G2 } from 'bizcharts'
import moment from 'moment'
import Sticky from 'react-stickynode'

type Props = {
  loadEarningsData: void => void,
  earningsByDate: Object[],
  isFetching: boolean
}

type State = {
  data: Object[]
}

class EarningsChart extends Component<Props, State> {

  state: State = {
    data: []
  }

	componentDidUpdate() {

    const { isFetching } = this.props 
    const { data } = this.state
    
    if (!isFetching && !data.length) this.loadChartData()
  }

  // --- Chart ---
  loadChartData() {

    const { earningsByDate } = this.props

    earningsByDate.forEach(({ date, announcements }, i: number) => {

      // confirmed and unconfirmed announcements
      let allConfirmed = []
      let allUnconfirmed = []

      announcements.forEach((announcement: Object, index: number) => {

        // update confirmation arrays
        if (announcement.confirmed === 'Confirmed') allConfirmed = [...allConfirmed, announcement]
        else allUnconfirmed = [...allUnconfirmed, announcement]

        if (index === announcements.length - 1) {

          // combine confirmation arrays and create data points
          allConfirmed.concat(allUnconfirmed)
            .forEach(({ confirmed, symbol, releaseToD, name, estimatedEPS }, pos: number) => {

              const newData: Object = {
                status: confirmed === 'Confirmed' ? 'Confirmed' : 'Unconfirmed',
                date: moment(date).format('M/D'),
                dateFull: moment(date).format('M/D/YYYY'),
                count: pos,
                symbol,
                releaseToD,
                name,
                estimatedEPS: estimatedEPS || 'n/a'
              }

              this.setState(({ data }) => ({
                data: [...data, newData]
              }))
          })
        }
      })
    })
  }
  
	render() {

    const { data } = this.state
    const { isFetching } = this.props

		return (
      <ChartCard 
        loading={isFetching}
        bordered={false} 
        title='Earnings Announcements'>
        
        { data.length ?
          <Sticky top={0}>
            <div style={{padding: '0 10px'}}>
              <Chart height={325}
            padding={[30,10,50,30]}
            background={{
            fill: '#fff',}}
            data={data}
            renderer='svg'
            plotBackground={{
              fill: '#fff',
              opacity: 1
            }}
            forceFit>

            <Tooltip 
              showTitle={false}
              crosshairs={{ type: 'cross' }}
              itemTpl='
                <li data-index={index} style="margin-bottom:4px;">
                  <span style="background-color:{color};" class="g2-tooltip-marker"></span>
                  {name}<br/>
                  {value}<br/>
                  {date}<br/>
                  {eps}             
                </li>' />

            <Axis name='date' label={xAxisLabel} />
            <Axis name='count' />
            <Legend position='top' />

            <Geom type='point'
              position='date*count'
              color={['status', (status: string) => status === 'Confirmed' ? '#1890ff' : '#ff040a']}
              opacity={0.65}
              shape='circle'
              size={2.15}
              tooltip={
                ['status*symbol*dateFull*releaseToD*name*estimatedEPS',
                (status, symbol, dateFull, releaseToD, name, estimatedEPS) => {
                  return {
                    name: status,
                    date: `${dateFull} - ${releaseToD}`,
                    value: `${symbol} - ${name}`,
                    eps: `Est EPS - ${estimatedEPS}`
                  }
                }]
              } />
          </Chart>
            </div>
          </Sticky> : null
        }
        {
          !isFetching && !data.length && <div style={{paddingLeft: 32}}>No Earnings data found!</div>
        }
      </ChartCard>
		)
	}
}

const mapStateToProps = (state: Object) => ({
  earningsByDate: state.earnings.earningsByDate,
  isFetching: state.earnings.isFetching
})

const mapDispatchToProps = (dispatch: Function) => ({
  loadEarningsData() {
    getDataChart(dispatch)
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EarningsChart)



// WEBPACK FOOTER //
// ./src/components/chart-earnings/index.js